module.exports = "/_next/static/media/onboard-1-grid.ec607da1.mp4";